export default "__VITE_ASSET__CVdLUYRJ__"